export const ArrowUpDate = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.52876 10.4507C3.78911 10.711 4.21122 10.711 4.47157 10.4507L8.00016 6.92208L11.5288 10.4507C11.7891 10.711 12.2112 10.711 12.4716 10.4507C12.7319 10.1903 12.7319 9.76821 12.4716 9.50786L8.54228 5.57864C8.24288 5.27924 7.75745 5.27924 7.45805 5.57864L3.52876 9.50786C3.26841 9.76821 3.26841 10.1903 3.52876 10.4507Z"
        fill="currentColor"
      />
    </svg>
  )
}
